// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
    overflow: auto;
}
.header-show {
    padding-left:12px;
    font-size:14px;
}
.menu-left {
    font-size: 14px;
    padding-left: 20px;
    float:left;
    font-weight: normal;
}
.menu-right {
    font-size: 14px;
    padding-right: 20px;
    float:right;
    font-weight: normal;
}
.menu-right-toggle {
    display: inline-block; 
    margin-right: 10px; 
    font-weight: normal;
}
.clearfix::after {
    content: "";
    display: table;
    clear: both;
}
.radio-button {
    width:100px;
}
.container-security {
    flex: 1;
    background: #fff;
    margin-left: 30px;
    margin-right: 30px;
    height: 105%;
}
.menu-title-text {
    font-size: 20px;
    padding: 8px 16px;
    margin-bottom: -2px;
    color: #555;
}

.menu-link {
    font-weight: bold; 
    text-decoration: underline;
}
.center-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.example-container {
    display: flex;  
    flex-direction: column;  
    max-height: 280px;  
    min-width: 200px;
}

.mat-table {  
    overflow: auto;  
    max-height: 280px;
    z-index: 2;
}

.mat-header-row {
    min-height: 38px;
}

.menu-title {
    margin-left:-16px;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
    padding: 15px 10px 5px 0;
}

.menu-header {
    background-color: #fff;
    position: fixed;
    left: 240px;
    top: 50px;
    height: 50px;
    right: 0;
    padding: 0 20px;
    z-index: 5;
}

.box-space{
    width: 100%;
    margin-right: 4px;
}

mat-accordion {
    width: 100%;
}

.panel-body {
    touch-action: none;
    padding: 0 24px 5px;
}

.security-accordion {
    display:inline-block;
    padding: 8px 2px;
}
 
.security-accordion-collapse {
    display:inline-block;
    padding: 2px 2px;
}

.security-scroll {
    height: auto;
    overflow-y: auto;
 }`, "",{"version":3,"sources":["webpack://./src/app/account/profile/security/edit-security.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;CACnB","sourcesContent":[".mat-dialog-content {\n    overflow: auto;\n}\n.header-show {\n    padding-left:12px;\n    font-size:14px;\n}\n.menu-left {\n    font-size: 14px;\n    padding-left: 20px;\n    float:left;\n    font-weight: normal;\n}\n.menu-right {\n    font-size: 14px;\n    padding-right: 20px;\n    float:right;\n    font-weight: normal;\n}\n.menu-right-toggle {\n    display: inline-block; \n    margin-right: 10px; \n    font-weight: normal;\n}\n.clearfix::after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.radio-button {\n    width:100px;\n}\n.container-security {\n    flex: 1;\n    background: #fff;\n    margin-left: 30px;\n    margin-right: 30px;\n    height: 105%;\n}\n.menu-title-text {\n    font-size: 20px;\n    padding: 8px 16px;\n    margin-bottom: -2px;\n    color: #555;\n}\n\n.menu-link {\n    font-weight: bold; \n    text-decoration: underline;\n}\n.center-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.example-container {\n    display: flex;  \n    flex-direction: column;  \n    max-height: 280px;  \n    min-width: 200px;\n}\n\n.mat-table {  \n    overflow: auto;  \n    max-height: 280px;\n    z-index: 2;\n}\n\n.mat-header-row {\n    min-height: 38px;\n}\n\n.menu-title {\n    margin-left:-16px;\n    align-items: center;\n    border-bottom: 1px solid #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n    padding: 15px 10px 5px 0;\n}\n\n.menu-header {\n    background-color: #fff;\n    position: fixed;\n    left: 240px;\n    top: 50px;\n    height: 50px;\n    right: 0;\n    padding: 0 20px;\n    z-index: 5;\n}\n\n.box-space{\n    width: 100%;\n    margin-right: 4px;\n}\n\nmat-accordion {\n    width: 100%;\n}\n\n.panel-body {\n    touch-action: none;\n    padding: 0 24px 5px;\n}\n\n.security-accordion {\n    display:inline-block;\n    padding: 8px 2px;\n}\n \n.security-accordion-collapse {\n    display:inline-block;\n    padding: 2px 2px;\n}\n\n.security-scroll {\n    height: auto;\n    overflow-y: auto;\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
